import { styled } from "@mui/system";

export const YourOrderWrapper = styled("div")(({ theme }) => ({
  margin: "80px auto 0",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "1rem 9rem",
  ".title": {
    fontSize: "50px",
    lineHeight: "57px",

    "@media (width <= 768px)": {
      textAlign: "center",
    },
  },
  ".order_card_container": {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "4rem",

    // padding: "1rem 9rem",
  },

  "@media (max-width:768px)": {
    margin: "40px auto 0",
    padding: "0 0.2rem",
    ".title": {
      fontSize: "40px",
    },
    ".order_card_container": {
      padding: "0 0.4rem",
      gap: "1.4rem",
    },
  },
}));
